import { render, staticRenderFns } from "./AppAnamnese.vue?vue&type=template&id=9d831630&"
import script from "./AppAnamnese.vue?vue&type=script&lang=js&"
export * from "./AppAnamnese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports